/**
 * Escape Hatch is a utility for handling [ESC] key presses.
 *
 * It allows nested modals (multiple overlayed modals that all use ESC to close) to work.
 *
 * It keeps a queue of escape hatches, the order determined by the order in which they are opened.
 *
 * When [ESC] is pressed, the last escape hatch is popped off the queue and called.
 *
 * The useEscapeHatch hook ensures that if a modal is closed using another method the escape hatch is removed from the queue.
 */
import React from "react";
import { Platform } from "react-native";
const escapeHatches = [];
if (Platform.OS === "web") {
    window.addEventListener("keydown", (event) => {
        if (event.key === "Escape") {
            const last = escapeHatches.pop();
            if (last != null) {
                last();
            }
        }
    });
}
export function useEscapeHatch(escapeHatch) {
    if (Platform.OS === "web") {
        React.useEffect(() => {
            escapeHatches.push(escapeHatch);
            return () => {
                const index = escapeHatches.indexOf(escapeHatch);
                if (index > -1) {
                    escapeHatches.splice(index, 1);
                }
            };
        }, [escapeHatch]);
    }
}
